import { Action } from 'redux'
import { SOCKET_STATUS_CHANGED, SocketStatus } from './actions'

/** The live socket's state, reported by webSocketMiddleware for the AIM status bar. */
export interface IConnectionState {
  socketStatus: SocketStatus
}

const initialState: IConnectionState = {
  socketStatus: SocketStatus.Connecting,
}

const connection = (
  state: IConnectionState = initialState,
  action: Action & { data?: { status?: SocketStatus } },
): IConnectionState => {
  if (action.type === SOCKET_STATUS_CHANGED && action.data?.status) {
    return state.socketStatus === action.data.status
      ? state
      : { ...state, socketStatus: action.data.status }
  }
  return state
}

export default connection
